<template>
  <div>
    <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone> -->
    <vue-dropzone
      @vdropzone-upload-progress="(file, progress, bytesSent) => this.progress(file, progress, bytesSent, 'LokalesHandwerk Drop')"
      @vdropzone-removed-file="loeschemedien"
      @vdropzone-success="medienuploadsuccess(); addToCollection()"
      ref="myVueDropzone"
      id="dz1"
      :options="dropzoneOptions"
    ></vue-dropzone>
    <!-- <v-btn @click="addToCollection()">event</v-btn> -->
    <!-- <v-btn @click="populate()">Populieren</v-btn>

      <v-btn @click="loeschealles()">Alles Löschen?!</v-btn>

    <v-btn @click="cleardrop()">Alles Löschen Frontend??!</v-btn>-->
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'

export default {
  name: 'app',
  components: {
    vueDropzone: vue2Dropzone
  },
  data: function () {
    return {
      dropzoneOptions: {
        url: '/api/v1/addmedia',
        uploadMultiple: false,
        thumbnailWidth: 180,
        dictDefaultMessage: 'Hier klicken zum Hochladen, oder einfach Dateien hier ablegen',
        dictFileTooBig: 'Datei leider zu groß',
        dictRemoveFile: 'Datei löschen',
          // dictRemoveFileConfirmation: "Datei wirklich löschen?",
        dictCancelUpload: 'Hochladen abbrechen',
        dictUploadCanceled: 'Abgebrochen',
        dictCancelUploadConfirmation: 'Wirklich abbrechen?',
        maxFilesize: 5,
        maxFiles: 50,
        addRemoveLinks: true

      }
    }
  },
  mounted () {
    this.populate()
  },
  methods: {
    populate () {
      var app = this
      console.log(this.$refs.myVueDropzone)

      axios.get('/api/v1/getmedialibrary')
                .then(function (response) {
                  console.log(response)
                  response.data.forEach(function (image, index) {
                    app.$refs.myVueDropzone.manuallyAddFile({ name: image.name, namedelete: image.file_name, size: 180, type: image.mime_type }, image.url)
                  })
                })
    },
    cleardrop () {
      this.$refs.myVueDropzone.removeAllFiles()
    },
    progress: function (file, progress, bytesSent, origin) {
      console.log(file.name, 'von', origin, progress, '% geschafft')
    },
    medienuploadsuccess: function (file, response) {
      // file.namedelete = response.namedelete
      // console.log(response)
      // console.log(file)
      // console.log(file.namedelete)
    },

    loeschemedien: function (file) {
      console.log(this.$refs.myVueDropzone)
      if (this.$refs.myVueDropzone.dropzone.disabled !== true) {
        console.log('lösche' + file.namedelete)
        // var app = this
        axios.post('/api/v1/loeschemedia', { namedelete: file.namedelete })
        .then((resp) => {
          this.$store.dispatch('responseMessage', {
            type: 'success',
            text: 'Datei gelöscht!'
          })

          console.log(resp)
        })
        .catch(function (resp) {
          console.log(resp)
        })
      }
    },
    addToCollection () {
      console.log('file added')
      this.$emit('fileadded')
    },
    loeschealles () {
     // var app = this
      axios.post('/api/v1/loescheallemedia')
      .then((resp) => {
        this.$store.dispatch('responseMessage', {
          type: 'success',
          text: 'Alles gelöscht!'
        })
      })
      .catch(function (resp) {
        console.log(resp)
      })
    }
  }
}

// import 'babel-polyfill'; // es6 shim

</script>

<style scoped>
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
}

.subtitle {
  color: #314b5f;
}
</style>